import { render, staticRenderFns } from "./StaffFilters.vue?vue&type=template&id=6a61c7f0"
import script from "./StaffFilters.vue?vue&type=script&lang=js"
export * from "./StaffFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports